<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import ExistingBet from './ExistingBet.vue'
import BetForm from './BetForm.vue'

const props = defineProps({
  event: Object,
  selectedOutcome: Object,
  isBettingDisabled: Boolean,
})

const emit = defineEmits(['show-message'])
const router = useRouter()
const { t } = useI18n()
const userStore = useUserStore()

const isAuthenticated = computed(() => userStore.isAuthenticated)
const hasExistingBet = computed(() => {
  return props.event?.user_bets && props.event.user_bets.length > 0
})
const existingBet = computed(() => {
  if (!hasExistingBet.value) return null
  return props.event.user_bets[0]
})
// isBettingDisabled viene ora passato come prop dal componente padre

const showMessage = (message, type = 'info') => {
  emit('show-message', { message, type })
}
</script>

<template>
  <v-card id="betting-panel" class="betting-panel" elevation="3" :disabled="isBettingDisabled && isAuthenticated">
    <v-card-title>
      <v-icon class="mr-2">mdi-cash</v-icon>
      {{ $t('events.betting.placeBet') }}
    </v-card-title>
    <v-card-text>
      <!-- Login prompt if not authenticated -->
      <div v-if="!isAuthenticated" class="text-center py-4">
        <v-icon size="48" color="primary" class="mb-4">mdi-account-circle</v-icon>
        <p class="text-subtitle-1 mb-4">{{ $t('events.betting.loginRequired') }}</p>
        <v-btn
          color="primary"
          @click="router.push({ name: 'login'})"
          prepend-icon="mdi-login"
        >
          {{ $t('common.login') }}
        </v-btn>
      </div>

      <!-- Betting form (BetForm now handles login / existing bet / disabled / select-to-bet logic) -->
      <BetForm
        :selectedOutcome="selectedOutcome"
        :event="event"
        :isBettingDisabled="isBettingDisabled"
        @bet-placed="showMessage(t('messages.success.betPlaced'), 'success')"
        @bet-error="showMessage($event.message, 'error')"
      />
    </v-card-text>



  </v-card>
</template>
